import React, {Component} from 'react';
import {Container as FluxContainer} from "flux/utils";
import SubscribeFromMarketplaceStore from "./SubscribeFromMarketplaceStore";
import {selectAuthenticationModalType, subscriptionRequestReceived} from "./Actions";
import {isAuthenticated} from "../../services/self";
import Register from "./components/Register";
import Login from "./components/Login";
import Subscribe from "./components/Subscribe";

class SubscribeFromMarketplace extends Component {
    static getStores() {
        return [SubscribeFromMarketplaceStore];
    }

    static calculateState() {
        return SubscribeFromMarketplaceStore.getState();
    }

    componentWillMount() {
        const authenticated = isAuthenticated() === true;
        subscriptionRequestReceived(this.props.match.params.token, authenticated, "register")
    }

    render() {
        const displayAuthenticationModal = this.state.displayAuthenticationModal;
        if (displayAuthenticationModal) {
            if (this.state.authenticationModalType === "register") {
                return (
                    <Register
                        formDisabled={this.state.formDisabled}
                        email={this.state.email}
                        password={this.state.password}
                        company={this.state.company}
                        formInfoMessage={this.state.formInfoMessage}
                        formErrorMessage={this.state.formErrorMessage}
                        onLoginOpen={SubscribeFromMarketplace.changeToLogin}
                        privacyAccepted={this.state.privacyAccepted}
                    />
                )
            } else {
                return (
                    <Login
                        formDisabled={this.state.formDisabled}
                        email={this.state.email}
                        password={this.state.password}
                        formInfoMessage={this.state.formInfoMessage}
                        formErrorMessage={this.state.formErrorMessage}
                        onRegisterOpen={SubscribeFromMarketplace.changeToRegister}
                    />
                )
            }
        } else {
            return (
                <Subscribe
                    token={this.state.token}
                    modalMessage={this.state.modalMessage}
                    success={this.state.success}
                    showSpinner={this.state.showSpinner}
                />
            )

        }
    }
}

export default FluxContainer.create(SubscribeFromMarketplace);


/** WEBPACK FOOTER **
 ** ./src/shared_states/SubscriptionRequest/SubscribeFromMarketplace.js
 **/